<template>
  <div>
    <Page/>
  </div>
</template>

<script>

import Page from '@/components/Page.vue'

export default {
  name: 'Home',
  components: {
    Page,
  }
}
</script>
